module.exports = __webpack_public_path__ + "h5/img/start.58c80835.png";